/* ==========================================================================
   OMG SUPPLY CO. — core behaviour
   Shared byte-identically between the static preview and the Shopify theme.

   One file, two cart backends:
     data-omg-mode="preview"  -> in-memory cart (static preview only)
     data-omg-mode="shopify"  -> Shopify AJAX Cart API (/cart/add.js etc.)
   Everything else — flavour tray, gallery, accordions, sticky buy bar —
   is identical in both.
   ========================================================================== */
(function () {
  'use strict';
  window.OMG_BOOTED = true;

  var root = document.documentElement;
  var MODE = document.body.getAttribute('data-omg-mode') || 'preview';
  var SHOP = document.body.getAttribute('data-omg-shop') || 'shop.html';
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00');
  };

  /* ---------------------------------------------------------------- state */
  var cart = { items: [] };
  try {
    var saved = window.sessionStorage.getItem('omg-cart');
    if (saved && MODE === 'preview') cart = JSON.parse(saved);
  } catch (e) { /* storage unavailable — in-memory is fine */ }

  function persist() {
    if (MODE !== 'preview') return;
    try { window.sessionStorage.setItem('omg-cart', JSON.stringify(cart)); } catch (e) {}
  }

  /* ---------------------------------------------------------------- toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('on'); }, 2200);
  }

  /* ----------------------------------------------------------- cart render */
  function count() {
    return cart.items.reduce(function (n, i) { return n + i.qty; }, 0);
  }
  function total() {
    return cart.items.reduce(function (n, i) { return n + i.qty * i.price; }, 0);
  }

  function paintCount() {
    var dots = document.querySelectorAll('[data-cart-count]');
    var n = count();
    for (var i = 0; i < dots.length; i++) {
      dots[i].textContent = n;
      dots[i].hidden = n === 0;
    }
  }

  /* A bundle is one cart line but holds several cups. Free shipping is earned by
     cups, not by lines, so count what is actually inside each line. */
  var SHIP_FREE_FROM = 2000; /* cents: free shipping on orders of 20.00 USD or more (matches the store's shipping rate) */
  function squishyUnits() {
    var n = 0;
    cart.items.forEach(function (it) {
      var raw = it.props && it.props.__mw_build;
      if (raw) {
        try {
          var o = JSON.parse(raw);
          o.items.forEach(function (x) { n += (x.qty || 0) * (it.qty || 1); });
          return;
        } catch (e) {}
      }
      n += it.qty || 0;
    });
    return n;
  }
  function bundleBits(props) {
    if (!props) return [];
    return Object.keys(props).filter(function (k) { return /^[0-9]+$/.test(k); })
      .sort(function (a, b) { return a - b; })
      .map(function (k) { return props[k]; });
  }

  /* Cart lines from Shopify's /cart.js (2026-10-22: keeps line keys, line prices
     and the cart total so quantity steppers and discounts display correctly). */
  function fromShopify(c) {
    cart.total = c.total_price;
    return c.items.map(function (i) {
      return { id: i.variant_id, key: i.key, title: i.product_title, qty: i.quantity,
        price: i.price, linePrice: i.final_line_price, origLine: i.original_line_price,
        variant: (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '',
        props: i.properties || {}, img: i.image };
    });
  }

  /* "You may also like" — real flavours printed by Liquid into #omg-recs. */
  var RECS = null;
  function recs() {
    if (RECS) return RECS;
    try { RECS = JSON.parse(document.getElementById('omg-recs').textContent) || []; } catch (e) { RECS = []; }
    return RECS;
  }
  function recsHtml() {
    var inCart = cart.items.map(function (i) { return String(i.id); });
    var all = recs().filter(function (p) { return p.available; });
    var list = all.filter(function (p) { return inCart.indexOf(String(p.id)) < 0; });
    if (!list.length) list = all;
    if (!list.length) return '';
    return '<div class="dwr"><p class="dwr__h">You may also like</p><div class="dwr__row">' +
      list.map(function (p) {
        return '<div class="dwr__c"><a class="dwr__m" href="' + p.url + '"><img src="' + p.img + '" alt="" loading="lazy" width="150" height="150"></a>' +
          '<a class="dwr__n" href="' + p.url + '">' + p.name + '</a><span class="dwr__p">' + money(p.price) + '</span>' +
          '<button class="dwr__add" data-add="' + p.id + '" data-title="' + p.title + '" data-price="' + p.price + '" data-img="' + p.img + '">Add to cart</button></div>';
      }).join('') + '</div></div>';
  }

  function paintDrawer() {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    var html = '';
    if (!cart.items.length) {
      html = '<div class="mt"><svg viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.4"/>' +
        '<circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 7H6"/></svg>' +
        '<p>Your cart is empty.</p><a class="b b--pink" href="' + SHOP +
        '">Shop Sip Squishy</a></div>' + recsHtml();
      body.innerHTML = html;
      if (foot) foot.hidden = true;
      return;
    }
    /* free-shipping progress, counted in cups (bundles count every cup inside) */
    var units = (cart.total != null ? cart.total : total()); /* cart total in cents */
    var done = units >= SHIP_FREE_FROM;
    var need = SHIP_FREE_FROM - units;
    var pct = Math.min(100, Math.round(units / SHIP_FREE_FROM * 100));
    html += '<div class="dwp' + (done ? ' dwp--on' : '') + '"><p class="dwp__t">' +
      (done ? "You've unlocked FREE shipping!" : "You're " + money(need) + " away from FREE shipping!") +
      '</p><div class="dwp__bar" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="' + SHIP_FREE_FROM +
      '" aria-valuenow="' + Math.min(units, SHIP_FREE_FROM) + '"><span style="width:' + pct + '%"></span></div></div>';
    cart.items.forEach(function (it, idx) {
      var bits = bundleBits(it.props);
      var name = it.title.replace('Sip Squishy \u2014 ', '');
      var line = it.linePrice != null ? it.linePrice : it.qty * it.price;
      var was = (it.origLine != null && it.origLine > line) ? '<s class="li__was">' + money(it.origLine) + '</s>' : '';
      html += '<div class="li">' +
        '<div class="li__m"><img src="' + it.img + '" alt="" loading="lazy" width="84" height="84"></div>' +
        '<div class="li__d"><b>' + name + '</b>' +
        (bits.length
          ? '<small>Your flavors:</small><ul class="li__bits">' + bits.map(function (x) {
              return '<li>' + String(x).replace('Sip Squishy \u2014 ', '') + '</li>'; }).join('') + '</ul>'
          : '<small>' + (it.variant ? 'Flavor: ' + it.variant : 'Sip Squishy') + '</small>') +
        '<div class="li__r"><div class="dwq"><button type="button" data-cart-step="' + idx + '" data-d="-1" aria-label="Decrease quantity of ' + name + '">&minus;</button>' +
        '<span aria-live="polite">' + it.qty + '</span>' +
        '<button type="button" data-cart-step="' + idx + '" data-d="1" aria-label="Increase quantity of ' + name + '">+</button></div>' +
        '<span class="li__p">' + money(line) + was + '</span></div>' +
        '<button class="li__x" data-cart-remove="' + idx + '">Remove</button></div></div>';
    });
    html += recsHtml();
    body.innerHTML = html;
    if (foot) {
      foot.hidden = false;
      var t = foot.querySelector('[data-cart-total]');
      if (t) t.textContent = money(cart.total != null ? cart.total : total());
      var msg = foot.querySelector('[data-ship-msg]');
      if (msg) { msg.className = 'shipmsg'; msg.textContent = ''; }
    }
  }


  // function paint() {
  window.paint = function () {
    paintCount(); paintDrawer(); persist();
    var line = document.querySelector('[data-cart-line]');
    if (line) {
      var n = count();
      line.textContent = n === 0 ? 'Nothing in it yet'
        : n + (n === 1 ? ' item' : ' items');
    }
  }

  /* ------------------------------------------------------------ cart verbs */
  function addLocal(item) {
    var hit = null;
    cart.items.forEach(function (i) { if (i.id === item.id) hit = i; });
    if (hit) hit.qty += item.qty; else cart.items.push(item);
    paint();
  }

  function add(item, btn) {
    if (MODE === 'shopify') {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: item.id, quantity: item.qty }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cart.items = fromShopify(c);
          paint();
          openDrawer();
          flash(btn);
        })
        .catch(function () { toast("Couldn't add that — please try again."); });
      return;
    }
    addLocal(item);
    openDrawer();
    flash(btn);
  }

  function flash(btn) {
    if (!btn) return;
    var was = btn.textContent;
    btn.textContent = 'Added';
    btn.classList.add('done');
    setTimeout(function () { btn.textContent = was; btn.classList.remove('done'); }, 1400);
  }

  function remove(idx) {
    if (MODE === 'shopify') {
      var line = cart.items[idx];
      if (!line) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: idx + 1, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cart.items = fromShopify(c);
          paint();
        });
      return;
    }
    cart.items.splice(idx, 1);
    paint();
  }

  /* quantity stepper in the cart drawer (2026-10-22) */
  var busy = false;
  function setQty(idx, q) {
    if (busy) return;
    if (MODE !== 'shopify') {
      if (q <= 0) cart.items.splice(idx, 1); else cart.items[idx].qty = q;
      paint(); return;
    }
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: idx + 1, quantity: q })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) { cart.items = fromShopify(c); paint(); } })
      .catch(function () { toast("Couldn't update the cart — please try again."); })
      .then(function () { busy = false; });
  }

  /* ---------------------------------------------------------------- drawer */
  var drawer = document.querySelector('[data-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('on');
    if (scrim) scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('button,a,input');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on');
    if (scrim) scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  /* ------------------------------------------------------- flavour orbit */
  /* The nine flavours sit on a ring seen almost edge-on. Dragging, the wheel,
     the arrow keys, a swipe or a click all rotate the ring; the charm at the
     front is the featured one and drives the headline, the accent colour and
     the product link. It never rotates on its own. */
  function applyFlavour(el) {
    if (!el) return;
    root.style.setProperty('--accent', el.dataset.ink);
    root.style.setProperty('--field', el.dataset.wash);
    var acc = document.querySelector('[data-accent-scope]');
    if (acc) acc.style.setProperty('--accent', el.dataset.ink);
    var nm = document.querySelector('[data-hero-name]');
    if (nm) nm.textContent = el.dataset.title;
    var sc = document.querySelector('[data-hero-scent]');
    if (sc) sc.textContent = el.dataset.scent || '';
    var lk = document.querySelector('[data-hero-link]');
    if (lk) lk.href = el.dataset.href;

    var chips = document.querySelectorAll('[data-flavour]');
    for (var i = 0; i < chips.length; i++) {
      var on = chips[i].dataset.title === el.dataset.title;
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  /* ---------------------------------------------------------- the ticker
     The strip is two identical runs. Once we know how wide one run actually
     is, the keyframe can translate the pair by exactly that distance, which is
     what makes the loop seamless: at the end of the cycle run two sits exactly
     where run one started. Speed is held constant in pixels per second so a
     longer message scrolls at the same pace, not faster.
     Nothing here runs under reduced motion — the CSS shows the messages still
     and this function leaves the element alone. */
  function bindTicker() {
    var strip = document.querySelector('[data-ann]');
    if (!strip) return;
    var vp = strip.querySelector('.ann__vp');
    var runs = strip.querySelectorAll('[data-ann-run]');
    if (!vp || runs.length < 2) return;
    if (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var PPS = 42;                                   // pixels per second
    function measure() {
      var w = runs[0].getBoundingClientRect().width;
      if (!w) return;
      // Repeat the run until the pair is comfortably wider than the screen, so
      // there is never a gap even on a very wide monitor.
      var need = Math.ceil((window.innerWidth * 1.2) / w);
      while (runs.length < need * 2 && runs.length < 24) {
        var clone = runs[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        vp.appendChild(clone);
        runs = strip.querySelectorAll('[data-ann-run]');
      }
      var span = w * Math.floor(runs.length / 2);
      vp.style.setProperty('--annrun', span + 'px');
      vp.style.setProperty('--anndur', (span / PPS).toFixed(2) + 's');
    }
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    var t = 0;
    window.addEventListener('resize', function () {
      clearTimeout(t); t = setTimeout(measure, 180);
    });
  }

  function bindOrbit() {
    var stage = document.querySelector('[data-orbit]');
    if (!stage) return;
    var items = [].slice.call(stage.querySelectorAll('[data-orbit-item]'));
    var N = items.length;
    if (!N) return;

    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var angle = 0, target = 0, raf = 0, featured = -1;
    var dragging = false, captured = false, moved = 0, startX = 0, startAngle = 0, lastX = 0, vel = 0, lastT = 0;

    function wrapDelta(d) {          // shortest way round the ring
      while (d > N / 2) d -= N;
      while (d < -N / 2) d += N;
      return d;
    }

    function layout() {
      var w = stage.clientWidth, h = stage.clientHeight;
      var rx = Math.min(w * 0.315, 238);
      var ry = Math.max(14, h * 0.085);
      for (var i = 0; i < N; i++) {
        // One step round the ring is a fixed 40 degrees rather than a
        // share of the circle, so the front charm keeps exactly one
        // flanker each side whether the ring holds four designs or nine.
        // With nine the two are the same angle, so the hero is unchanged.
        var th = wrapDelta(i - angle) * (Math.PI * 2 / 9);
        var c = Math.cos(th), s = Math.sin(th);
        var depth = (c + 1) / 2;                      // 1 at the front, 0 at the back
        var sc = 0.40 + Math.pow(depth, 3.0) * 0.86;
        var x = s * rx;
        var y = -c * ry * 0.5 + (1 - depth) * ry * 1.4;
        // Only the front charm and its two neighbours are shown, so the stage
        // reads as one hero product with a flanker each side rather than a ring
        // of nine. Everything further round fades out completely.
        var vis = depth < 0.58 ? 0 : Math.min(1, (depth - 0.58) / 0.20);
        var el = items[i];
        el.style.transform = 'translate(-50%,-50%) translate(' + x.toFixed(1) + 'px,' +
          y.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        el.style.zIndex = String(Math.round(depth * 100) + 1);
        el.style.opacity = (vis * (0.55 + depth * 0.45)).toFixed(3);
        el.style.pointerEvents = depth > 0.30 ? 'auto' : 'none';
        el.tabIndex = depth > 0.30 ? 0 : -1;
      }
      var f = ((Math.round(angle) % N) + N) % N;
      if (f !== featured) {
        featured = f;
        for (var j = 0; j < N; j++) {
          items[j].setAttribute('data-featured', j === f ? 'true' : 'false');
          items[j].setAttribute('aria-current', j === f ? 'true' : 'false');
        }
        applyFlavour(items[f]);
      }
    }

    function tick() {
      var d = target - angle;
      if (Math.abs(d) < 0.0008) { angle = target; layout(); raf = 0; return; }
      angle += d * 0.17;
      layout();
      raf = requestAnimationFrame(tick);
    }

    function run() {
      if (reduce) { angle = target; layout(); return; }
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function goTo(i) { target = angle + wrapDelta(i - ((angle % N) + N) % N); run(); }
    function step(n) { target = Math.round(target) + n; run(); }

    /* ---- drag and swipe ---- */
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; moved = 0;
      startX = lastX = e.clientX; startAngle = angle; vel = 0; lastT = e.timeStamp;
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      // Pointer capture waits until the pointer has actually travelled. Taken
      // on pointerdown, it retargets the click to the stage, so a plain click
      // on a charm never reached the charm's own handler on desktop.
      captured = false;
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var stepPx = Math.max(90, stage.clientWidth * 0.2);
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (!captured && moved > 6) {
        captured = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      angle = startAngle - dx / stepPx;
      var dt = e.timeStamp - lastT;
      if (dt > 0) vel = (e.clientX - lastX) / dt;
      lastX = e.clientX; lastT = e.timeStamp;
      layout();
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { stage.releasePointerCapture(e.pointerId); } catch (err) {}
      var stepPx = Math.max(90, stage.clientWidth * 0.2);
      var fling = -(vel * 170) / stepPx;
      target = Math.round(angle + Math.max(-2, Math.min(2, fling)));
      run();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    /* ---- wheel: horizontal intent only, so the page still scrolls ---- */
    var acc = 0;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      acc += e.deltaX;
      if (Math.abs(acc) > 40) { step(acc > 0 ? 1 : -1); acc = 0; }
    }, { passive: false });

    /* ---- click: bring a charm forward, or open the one already in front ---- */
    items.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); return; }
        if (i === featured) { window.location.href = el.dataset.href; return; }
        e.preventDefault(); goTo(i);
      });
    });

    /* ---- keyboard ---- */
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      else if (e.key === 'End') { e.preventDefault(); goTo(N - 1); }
    });
    items.forEach(function (el, i) {
      el.addEventListener('focus', function () { if (i !== featured) goTo(i); });
    });

    /* ---- the chips select a flavour too ---- */
    var chips = document.querySelectorAll('[data-flavour]');
    for (var c = 0; c < chips.length; c++) {
      (function (idx) {
        chips[idx].addEventListener('click', function () { goTo(idx % N); });
      })(c);
    }

    window.addEventListener('resize', layout);
    layout();
  }

  /* -------------------------------------------------------------- gallery */
  function bindGallery() {
    var main = document.querySelector('[data-gal-main]');
    if (!main) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-thumb]');
      if (!t) return;
      if (t.dataset.video) { var vid = document.querySelector('[data-gal-video]'); if (!vid) { vid = document.createElement('video'); vid.setAttribute('data-gal-video', ''); vid.controls = true; vid.playsInline = true; vid.preload = 'metadata'; vid.style.position = 'absolute'; vid.style.top = '0'; vid.style.left = '0'; vid.style.width = '100%'; vid.style.height = '100%'; vid.style.objectFit = 'contain'; vid.style.background = '#fff'; main.parentNode.style.position = 'relative'; main.parentNode.appendChild(vid); } vid.src = t.dataset.video; vid.poster = t.dataset.full; vid.style.display = ''; main.style.display = 'none'; var p = vid.play(); if (p) { p.catch(function(){}); } } else { var old = document.querySelector('[data-gal-video]'); if (old) { old.pause(); old.style.display = 'none'; } main.style.display = ''; main.src = t.dataset.full; }
      var row = t.parentNode;
      if (row && row.scrollWidth > row.clientWidth + 1) {
        t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      main.classList.remove('swap');
      void main.offsetWidth;
      main.classList.add('swap');
      var all = document.querySelectorAll('[data-gal-thumb]');
      for (var i = 0; i < all.length; i++) {
        all[i].setAttribute('aria-current', all[i] === t ? 'true' : 'false');
      }
    });

    /* The arrows either side of the thumbnail row step the selection along and
       wrap, so a keyboard or a thumb reaches all three without hunting for the
       small targets. They simply click the next thumbnail, which keeps one code
       path for changing the image. */
    document.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-gal-step]');
      if (!nav) return;
      var all = document.querySelectorAll('[data-gal-thumb]');
      if (!all.length) return;
      var at = 0;
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('aria-current') === 'true') { at = i; break; }
      }
      var to = (at + (+nav.dataset.galStep) + all.length) % all.length;
      all[to].click();
    });
  }

  /* --------------------------------------------------------- sticky buy */
  function bindSticky() {
    var bar = document.querySelector('[data-sticky]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('on', !entries[0].isIntersecting);
    }, { rootMargin: '-10px 0px 0px 0px' }).observe(anchor);
  }

  /* ------------------------------------------------------------ delegation */
  document.addEventListener('click', function (e) {
    var t;


    if ((t = e.target.closest('.t'))) {
      if (!e.target.closest('button') && !e.target.closest('a')) {
        var dest = t.querySelector('.t__hit') || t.querySelector('.t__n');
        if (dest && dest.href) { window.location.href = dest.href; return; }
      }
    }

    if ((t = e.target.closest('[data-add]'))) {
      e.preventDefault();
      var qtyIn = t.closest('.buyrow') ? document.querySelector('[data-qty-input]') : null;
      add({
        id: t.dataset.add,
        title: t.dataset.title,
        price: parseInt(t.dataset.price, 10),
        // The cart outlives the page it was filled from, and a product page's
        // "../assets/..." does not resolve from the homepage. Storing the
        // resolved URL keeps the thumbnail right wherever the drawer is opened.
        // On Shopify the value is already an absolute CDN URL, so this is a
        // no-op there.
        img: t.dataset.img ? new URL(t.dataset.img, location.href).href : '',
        qty: qtyIn ? Math.max(1, parseInt(qtyIn.value, 10) || 1) : 1
      }, t);
      return;
    }

    if ((t = e.target.closest('[data-cart-step]'))) {
      var ix = parseInt(t.dataset.cartStep, 10), ln = cart.items[ix];
      if (ln) setQty(ix, Math.max(0, ln.qty + parseInt(t.dataset.d, 10)));
      return;
    }
    if ((t = e.target.closest('[data-cart-remove]'))) {
      remove(parseInt(t.dataset.cartRemove, 10)); return;
    }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-scrim]')) { closeDrawer(); return; }

    if ((t = e.target.closest('[data-burger]'))) {
      var m = document.querySelector('[data-mnav]');
      if (m) {
        var open = m.classList.toggle('on');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // The menu is reachable at every width now, so it needs the two ways people
    // expect to dismiss a dropdown: picking a link, or clicking away from it.
    if (e.target.closest('[data-mnav] a')) { closeMenu(); return; }
    if (!e.target.closest('[data-mnav]')) closeMenu();

    if ((t = e.target.closest('.spec__q'))) {
      var open2 = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', open2 ? 'false' : 'true');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('on', !open2);
      return;
    }

    if ((t = e.target.closest('[data-qty]'))) {
      var input = document.querySelector('[data-qty-input]');
      if (!input) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(t.dataset.qty, 10));
      input.value = v;
      return;
    }
  });

  function closeMenu() {
    var m = document.querySelector('[data-mnav]');
    if (!m || !m.classList.contains('on')) return;
    m.classList.remove('on');
    var b = document.querySelector('[data-burger]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); }
  });

  // Email capture is NOT connected. The Shopify theme posts to a real Shopify
  // customer form; the static preview deliberately does nothing on submit
  // rather than faking a success message.
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-signup]');
    if (!f || MODE === 'shopify') return;
    e.preventDefault();
  });

  /* --------------------------------------------------------- squish trail */
  /* A short-lived goo mark follows a real mouse across the page. Deliberately
     small: one fixed-size pool of nodes that is reused for the life of the
     page, so nothing accumulates; pointer-events are off so it can never
     intercept a click; and it is not built at all for touch, for reduced
     motion, or on a narrow screen. */
  function bindTrail() {
    var fine = window.matchMedia('(hover:hover) and (pointer:fine)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!fine.matches || still.matches || window.innerWidth < 900) return;

    var COLORS = ['#F3479E', '#2B4FD8', '#7B34C4', '#0AA2DC', '#6FB80A',
                  '#0FB5AC', '#F59300', '#E0A006'];
    var POOL = 14, GAP = 46, LIFE = 620;

    var layer = document.createElement('div');
    layer.className = 'goo';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    var nodes = [], i;
    for (i = 0; i < POOL; i++) {
      var n = document.createElement('span');
      n.className = 'goo__b';
      layer.appendChild(n);
      nodes.push(n);
    }

    var next = 0, lastX = 0, lastY = 0, primed = false, queued = false;
    var px = 0, py = 0;

    function drop() {
      queued = false;
      var dx = px - lastX, dy = py - lastY;
      if (primed && dx * dx + dy * dy < GAP * GAP) return;
      lastX = px; lastY = py; primed = true;

      var el = nodes[next];
      next = (next + 1) % POOL;
      var size = 9 + Math.random() * 13;
      el.style.setProperty('--c', COLORS[(Math.random() * COLORS.length) | 0]);
      el.style.width = el.style.height = size.toFixed(0) + 'px';
      el.style.left = (px - size / 2).toFixed(0) + 'px';
      el.style.top = (py - size / 2).toFixed(0) + 'px';
      el.style.setProperty('--r', ((Math.random() * 90) | 0) + 'deg');
      /* restart the animation on a reused node */
      el.classList.remove('on');
      void el.offsetWidth;
      el.classList.add('on');
      window.setTimeout(function () { el.classList.remove('on'); }, LIFE);
    }

    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      px = e.clientX; py = e.clientY;
      if (!queued) { queued = true; window.requestAnimationFrame(drop); }
    }, { passive: true });

    /* stop drawing when the tab is hidden, and clear what is on screen */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        for (var k = 0; k < nodes.length; k++) nodes[k].classList.remove('on');
      }
    });
  }

  /* ------------------------------------------------------------------ boot */
  // Shopify: the cart lives on Shopify, so read it on every page load.
  if (MODE === 'shopify') {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart.items = fromShopify(c);
        paint();
      })
      .catch(function () {});
  }
  bindTrail();
  bindTicker();
  bindOrbit();
  bindGallery();
  bindSticky();
  paint();

  /* the orbit sets the opening flavour from whichever charm is at the front */

  if (MODE === 'shopify') {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart.items = fromShopify(c);
        paint();
      })
      .catch(function () {});
  }

  if (window.Shopify && window.Shopify.designMode) {
    var rebind = function () {
      bindTicker();
      bindOrbit();
      bindGallery();
      bindSticky();
      paint();
    };
    document.addEventListener('shopify:section:load', rebind);
    document.addEventListener('shopify:block:select', rebind);
  }
})();

/* ---------------------------------------------------------------- NOTIFY ME
   A flavour alert sign-up. The flavour comes from the button that opened the
   dialog. Consent for marketing is a separate, unticked box, so asking to hear
   about one flavour never signs anyone up for campaigns.

   While "Save sign-ups to Shopify" is off the dialog validates and confirms
   without creating anything - safe to click through on a draft. With it on it
   posts Shopify's own customer form, so no API key is ever in the page, and
   the flavour travels as a customer tag the store can segment on. */
(function () {
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var SEEN = 'omg_notify_seen';

  function seen() { try { return JSON.parse(localStorage.getItem(SEEN) || '[]'); } catch (e) { return []; } }
  function remember(k) { try { var a = seen(); if (a.indexOf(k) < 0) { a.push(k); localStorage.setItem(SEEN, JSON.stringify(a)); } } catch (e) {} }

  function box() { return document.querySelector('[data-nfy]'); }
  function open(flavour) {
    var b = box(); if (!b) return;
    b.querySelector('[data-nfy-flavour]').value = flavour;
    var sub = b.querySelector('[data-nfy-sub]');
    if (sub && !sub.dataset.tpl) sub.dataset.tpl = sub.textContent;
    if (sub) sub.textContent = flavour + ' \u2014 ' + sub.dataset.tpl;
    b.querySelector('[data-nfy-form]').hidden = false;
    b.querySelector('[data-nfy-ok]').hidden = true;
    b.querySelector('[data-nfy-err]').hidden = true;
    b.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var i = b.querySelector('[data-nfy-email]'); if (i) setTimeout(function () { i.focus(); }, 40);
  }
  function close() {
    var b = box(); if (!b) return;
    b.hidden = true; document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-notify]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-notify')); return; }
    if (e.target.closest('[data-nfy-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    var b = box();
    if (e.key === 'Escape' && b && !b.hidden) close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nfy-form]');
    if (!form) return;
    e.preventDefault();
    var b = box();
    var email = (form.querySelector('[data-nfy-email]').value || '').trim();
    var flavour = form.querySelector('[data-nfy-flavour]').value || '';
    var optin = form.querySelector('[data-nfy-optin]').checked;
    var err = form.querySelector('[data-nfy-err]');

    if (!EMAIL.test(email)) {
      err.textContent = 'That email address does not look right.';
      err.hidden = false; return;
    }
    err.hidden = true;

    var key = flavour.toLowerCase() + '|' + email.toLowerCase();
    var already = seen().indexOf(key) >= 0;

    function done() {
      remember(key);
      var ok = b.querySelector('[data-nfy-ok]');
      b.querySelector('[data-nfy-okt]').textContent = already
        ? 'You are already on the list for ' + flavour + '. We will not add you twice.'
        : 'You\u2019re on the list! We\u2019ll let you know when ' + flavour + ' drops!';
      form.hidden = true; ok.hidden = false;
      form.reset();
    }

    if (already || b.getAttribute('data-nfy-save') !== '1') { done(); return; }

    var tags = 'notify-me,flavor-' + flavour.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    if (optin) tags += ',newsletter';
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', tags);
    var btn = form.querySelector('[data-nfy-submit]');
    if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = 'Saving\u2026'; }
    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t; }
        if (!r.ok) throw new Error('http ' + r.status);
        done();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t; }
        err.textContent = 'That did not go through. Please try again in a moment.';
        err.hidden = false;
      });
  });
})();

/* ------------------------------------------- footer sign-up confirmation
   Shopify sends the page back with customer_posted=true after a successful
   newsletter submit. Liquid already reveals the confirmation on that render;
   this covers the case where the flag arrives on the URL instead. */
(function () {
  if (location.search.indexOf('customer_posted=true') < 0) return;
  var ok = document.querySelector('[data-ft-ok]');
  if (!ok) return;
  ok.hidden = false;
  var f = document.getElementById('omg-signup');
  if (f) f.hidden = true;
  ok.scrollIntoView({ block: 'center' });
})();
